import { render, staticRenderFns } from "./WxMerchant.vue?vue&type=template&id=07e8a81c&scoped=true&"
import script from "./WxMerchant.vue?vue&type=script&lang=js&"
export * from "./WxMerchant.vue?vue&type=script&lang=js&"
import style0 from "./WxMerchant.vue?vue&type=style&index=0&id=07e8a81c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07e8a81c",
  null
  
)

export default component.exports